module.exports = __webpack_public_path__ + "static/media/cases_3d_04d.338bfa29.jpg";